import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-rating-graph',
  templateUrl: './rating-graph.component.html',
  styleUrl: './rating-graph.component.scss'
})
export class RatingGraphComponent {

  @Input() ratingUserID:string = ''
  isSkelition: boolean = false
  lineChartOptions = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: 'SSTArabic'
          }
        },
        display: false
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
          color :'white',
          autoSkip: false,
          maxTicksLimit: 10,
          maxRotation: 90,
        }
      },
      y: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
            color :'white',
          stepSize: 1
        }
      }
    }
  };

  trainingType:any;
  selectedType:any;
  graphData:any[] = [];
  ratingLimit:number = 10;
  graphLabels:any;
  graphDatas:any;
  showGraph: boolean = false

  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
  ) { }


  ngOnInit() {
    this.isSkelition = true;
    this.getRating().then(() => {
      this.trainingType = this.pluckType(this.graphData)
      this.graphDatas  = this.pluckData(this.graphData);
      this.graphLabels = this.pluckLabels(this.graphData);
      this.graphData = this.getLineGraph();
      this.isSkelition = false;
    });
  }

  async getRating() {
    try {
      let uid = localStorage.getItem('uid');
      let ratingFor = 'User';
      const externalUserString = localStorage.getItem('externalUser');
      if (externalUserString) {
        const externalUser = JSON.parse(externalUserString);
        if (externalUser && externalUser.role == 'trainer') {
          ratingFor = 'Trainer'
        }
      }

      if (this.ratingUserID != ''){
        uid = this.ratingUserID;
        ratingFor = 'Trainer';
      }
      
      let data: any = {
        'ratingForID': uid,
        'ratingFor': ratingFor,
        'limit': this.ratingLimit
      }

      if (this.selectedType)
      {
       data.type_id = this.selectedType 
      }
      
      let res = await this.dataService.postData(`survey-attempt/getAvgRating`,data)
      if (res.error) {
        return
      }

      this.showGraph = (res.data.length > 0) ? true : false
      this.graphData = res.data;

    } catch (error) {
      console.log(error)
    }
  }

  translate(value: string) {
    const pipe: TranslatorPipe = new TranslatorPipe();
    return pipe.transform(value);
  }
  
  getLineGraph(): any {
    return {
      labels: this.labelmaker(this.graphLabels),
      datasets: [
        {
          backgroundColor: '#1e90ff',
          label: this.translate("Average Rating"),
          data: this.graphDatas,
        }
      ]
    };
  }

  labelmaker(inputArray: string[]): string[][] {
    const result: string[][] = [];
    inputArray.forEach(item => {
        if (item.length <= 10) {
            result.push([item]);
        } else {
            result.push(["..." + item.substring(0, 20)]);
        }
    });
    return result;
  }

  pluckLabels(data: any[]): string[] {
    return data.map(item => item.course);
  }

  pluckData(data: any[]): string[] {
    return data.map(item => item.avg_rating);
  }

  pluckType(data: any[]): { id: string, type: string }[] {
    return data.map(item => ({ id: item.type_id, type: item.training_type }));
  }
}
